import React from 'react';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeThreeFooter = ({ operator }) => {
	const openWhatsapp = () => {
		window.open(`//api.whatsapp.com/send?phone=${operator.phone_number}`, "_blank");
	};
	return (
		operator && (


			<div className="themes-theme-three-footer ">
				{operator && operator.operator_name === "ivergrama" ?
					(
						// <div className="fixed-whtsapp">

						// 	<img src="/assets/ivergrama/home/whtsapp.svg" />
						// </div>
						<div
							style={{
								position: "fixed",
								bottom: "24px",
								right: "24px",
								zIndex: 1000,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								cursor: "pointer",
							}}
							onClick={openWhatsapp}
						>
							<img
								src="/assets/ivergrama/Home/whtsapp.svg"
								style={{ marginRight: "10px" }}
								height={50}
								width={50}
							/>
						</div>
					) : (null)
				}

				<div
					style={{
						color:
							operator &&
							operator.color_codes &&
							operator.color_codes.secondary_text_color &&
							operator.color_codes.secondary_text_color,
					}}
				>
					<div
						className="d-flex-c p-4"
						style={{
							background:
								operator &&
								operator.color_codes &&
								operator.color_codes.footer_color &&
								operator.color_codes.footer_color,
						}}
					>
						<div className="footer-center">
							<div className="logo">
								<a href="/">
									<img
										// src={getIcons('footerLogo', operator)}
										src={operator && operator.footer_logo && operator.footer_logo}
										// alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
										style={{
											marginTop: '0',
											width: operator && operator.footer_logo_width && operator.footer_logo_width,
											height: operator && operator.operator_name === 'busnorte' ? 27 : operator && operator.operator_name === 'arzola' ? "" : 50,
										}}
										alt=""
									/>
								</a>
							</div>

							<style>
								.fb{'{'}
								background-image: url({getIcons('fb', operator)}); {'}'}
								.fb:hover{'{'}
								background-image: url({getIcons('fbHover', operator)}); {'}'}

								.twitter{'{'}
								background-image: url({getIcons('twitter', operator)}); {'}'}
								.twitter:hover{'{'}
								background-image: url({getIcons('twitterHover', operator)}); {'}'}

								.instagram{'{'}
								background-image: url({getIcons('instagram', operator)}); {'}'}

								.instagram:hover{'{'}
								background-image: url({getIcons('instagramHover', operator)}); {'}'}

								.fbb{'{'}
								background-image: url({getIcons('contactfb', operator)}); {'}'}

								.fbb:hover{'{'}
								background-image: url({getIcons('contactfbhover', operator)}); {'}'}
								.instagramm{'{'}
								background-image: url({getIcons('contactinsta', operator)}); {'}'}
								.instagramm:hover{'{'}
								background-image: url({getIcons('contactinstahover', operator)}); {'}'}

							</style>
							{operator && operator.operator_name === 'busnorte' ?
								(< div className="contact-links">
									<a href="https://www.facebook.com/busnorteoficial" target="_blank">
										<span class="fb social"></span>
									</a>
									<a href="https://www.instagram.com/busnorteoficial/" target="_blank">
										<span class="twitter social"></span>
									</a>
									{operator.email ? (
										<div className="email">
											<img src={getIcons('footen', operator)} alt="DIS" className="email_icon" />
											{operator.email}
										</div>
									) : null}
								</div>) : (< div className="contact-links">
									{operator && operator.operator_name === "aeroquinta" ? <a href='https://www.facebook.com/people/Buses-Aeroquinta/61562486544013/?mibextid=ZbWKwL' target='_blank'> <span class="fb social"></span></a> : null}

									{operator && operator.operator_name === "aeroquinta" ? <a href='	https://www.instagram.com/buses.aeroquinta/?igsh=YXZzdTI1MHpqd3pi' target='_blank'> <span class="instagram social"></span></a> : null}

									{operator && operator.operator_name === "ivergrama" ? <a href='https://www.facebook.com/people/Buses-Ivergrama/100063524885594/' target='_blank'> <span class="fb social"></span></a> : null}
									{operator && operator.operator_name === "ivergrama" ? <a href='https://x.com/i/flow/login?redirect_after_login=%2Fbusesiver' target='_blank'> <span class="twitter social"></span></a> : null}

									{operator && operator.operator_name === "basetorres" ? <a href='https://www.facebook.com/people/Buses-Base-Torres/100064765328472/?_rdr' target='_blank'> <span class="fbb social"></span></a> : null}

									{operator && operator.operator_name === "basetorres" ? <a href='	https://www.instagram.com/busesbasetorres/?hl=es-la' target='_blank'> <span class="instagramm social"></span></a> : null}
									{/* 
									{operator && operator.operator_name === "arzola" ? <a href='https://www.facebook.com/people/Buses-Ivergrama/100063524885594/' target='_blank'> <span class="fb social"></span></a> : null}
									{operator && operator.operator_name === "arzola" ? <a href='https://x.com/i/flow/login?redirect_after_login=%2Fbusesiver' target='_blank'> <span class="twitter social"></span></a> : null} */}

									{operator.email && operator.operator_name !== "basetorres" ? (
										<div className="email">
											<img src={getIcons('email', operator)} alt="DIS" className="email_icon" />
											{operator.email}
										</div>
									) : operator && operator.operator_name === "basetorres" ?
										(<a href='/torres-terms' className='tnc'>Términos de uso</a>)

										:
										null}
								</div>)
							}



						</div>
					</div>

					{operator && operator.show_bottom_footer ? (
						<ShowBottomFooter operator={operator} />
					) : null}
				</div>
			</div >
		)
	);
};
const ShowBottomFooter = ({ operator }) => {
	return (
		<div
			className="d-flex-c  p-2 sub_footer"
			style={{
				background: operator && operator.color_codes ? operator.color_codes.sub_footer_color : '',
				color: operator.text_color,
			}}
		>
			<div>
				<span>
					{operator.name} {new Date().getFullYear()}
				</span>
				<span>
					{' '}
					- Todos los derechos reservados © |
					<span className="less-bold-text"> Mapa del sitio </span> | Powered by
				</span>
				<a href="https://kupos.cl" target="_blank">
					<img
						src={getIcons('BottomFooterKuposLogo', operator)}
						// alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
						className="footer-kupos-logo"
						alt=""
					/>
				</a>
			</div>
		</div>
	);
};
/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators({ ...actions }, dispatch)
//   };
// }

export default connect(mapStateToProps, {})(ThemeThreeFooter);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/common/ThemeThreeFooter.js